import { cn } from '@/utils/classnames';

export type MaterialIconWeight = 300 | 400 | 500 | 600;

export interface MaterialIconProps {
  name: string;
  /** Pixel size (defaults to 20px). */
  size?: number;
  weight?: MaterialIconWeight;
  filled?: boolean;
  className?: string;
  'aria-hidden'?: boolean;
}

/**
 * Wraps a Google Material Symbols Outlined glyph.
 * The font is loaded once via index.html.
 */
export function MaterialIcon({
  name,
  size = 20,
  weight = 400,
  filled = false,
  className,
  'aria-hidden': ariaHidden = true,
}: MaterialIconProps) {
  const fontVariationSettings = `'FILL' ${filled ? 1 : 0}, 'wght' ${weight}, 'GRAD' 0, 'opsz' ${size}`;
  return (
    <span
      aria-hidden={ariaHidden}
      className={cn('material-symbols-outlined select-none leading-none', className)}
      style={{ fontSize: `${size}px`, lineHeight: `${size}px`, fontVariationSettings }}
    >
      {name}
    </span>
  );
}
